
import React from "react";
import Btn from "./common/Btn";
import PageHead from "./common/PageHead";
import TagBadge from "./common/TagBadge";
import { i18nManager } from "../i18n";
import { IMerchItem, MERCH } from "../data";
import styles from "../assets/style.module.css";
import { IProfileWebsite } from "../../../../services";

export interface StoreProps {
    website: IProfileWebsite;
    onAddToCart: (item: IMerchItem) => void;
}

function Store({ onAddToCart }: StoreProps) {

    const labels = i18nManager.Labels.store;

    return (<>
        <PageHead kicker={labels.kicker} title={labels.title} titleEm={labels.title_em} subtitle={labels.desc} />
        <section className={styles["section"]}>
            <div className={styles["container"]}>
                <div className={styles["store-grid"]}>
                    {MERCH.map((item) => (<div key={item.id} className={styles["product"]}>
                        <div className={styles["product-img"]}>
                            <img src={item.img} alt={item.name} loading="lazy" />
                            {item.badge && (<TagBadge>{item.badge}</TagBadge>)}
                        </div>
                        <div className={styles["product-body"]}>
                            <div className={styles["product-name"]}>{item.name}</div>
                            <div className={styles["product-foot"]}>
                                <div className={styles["product-price"]}>${item.price}</div>
                                <Btn size="sm" variant="dark" onClick={() => onAddToCart(item)}>{labels.add_to_cart}</Btn>
                            </div>
                        </div>
                    </div>))}
                </div>
            </div>
        </section>
    </>);
}

export default Store;
